import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";

const ThankYou = (props) => {
  // TODO: include more info for telehealth
  const peripheralData =
    props.deviceSelection.data.peripheral_type === "handfoot"
      ? {
          product: "Motus Hand & Foot",
          price: "$1098",
          protection: "$100",
          shipping: "$78",
          total: props.deviceProtection === "Yes" ? "$1276" : "$1176",
        }
      : props.deviceSelection.data.peripheral_type === "foot"
      ? {
          product: "Motus Foot",
          price: "$699",
          protection: "$50",
          shipping: "$39",
          total: props.deviceProtection === "Yes" ? "$788" : "$738",
        }
      : {
          product: "Motus Hand",
          price: "$399",
          protection: "$50",
          shipping: "$39",
          total: props.deviceProtection === "Yes" ? "$488" : "$438",
        };

  return (
    <Container maxWidth="md">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h3">Thank you!</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">Order Details</Typography>
        </Grid>
        <Grid container direction="row" item xs={6}>
          <Grid item xs={12}>
            <Typography variant="h6">Product:</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Subtotal:</Typography>
          </Grid>
          {props.deviceProtection === "Yes" ? (
            <Grid item xs={12}>
              <Typography variant="h6">Protection:</Typography>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <Typography variant="h6">Shipping:</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Total:</Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" item xs={6}>
          <Grid item xs={12}>
            <Typography variant="h6">{peripheralData.product}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">{peripheralData.price}</Typography>
          </Grid>
          {props.deviceProtection === "Yes" ? (
            <Grid item xs={12}>
              <Typography variant="h6">{peripheralData.protection}</Typography>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <Typography variant="h6">{peripheralData.shipping}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">{peripheralData.total}</Typography>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1">
            You will receive an email with this information shortly!
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            style={{ background: "#464d7c" }}
            fullWidth
            size="large"
            href="https://motusnova.com"
            target="_top"
            variant="contained"
            color="primary"
            disableElevation
          >
            Return to Motus Nova Homepage
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ThankYou;
